export const DEPLOY__ENV = (data = {}) => {
  const isReg = /tst|uat|prd/g;
  const { origin } = location;
  const arr = origin.match(isReg) || [];
  let result = '';
  result = arr.length && arr[0] || 'prd';
  return data[result];
};

export const getEnv = () => {
  if (window.location.hostname.indexOf('localhost') !== -1) {
    return 'dev';
  }
  if (window.location.hostname.indexOf('127.0.0.1') !== -1) {
    return 'dev';
  }
  if (window.location.hostname.indexOf('dev') !== -1) {
    return 'dev';
  }
  if (window.location.hostname.indexOf('test') !== -1) {
    return 'test';
  }
  if (window.location.hostname.indexOf('tst') !== -1) {
    return 'test';
  }
  if (window.location.hostname.indexOf('pre') !== -1) {
    return 'pre';
  }
  if (window.location.hostname.indexOf('uat') !== -1) {
    return 'pre';
  }
  return 'prd';
};

export const getHospitalHostname = () => {
  if (getEnv() === 'dev' || getEnv() === 'test') {
    return 'online-tst.za-doctor.com';
  } if (getEnv() === 'pre') {
    return 'online-uat.za-doctor.com';
  }
  return 'online.za-doctor.com';
};
